module.exports = "/img/close.svg?e2faeacd4f09b5b0b47ee2d8e808420d";